export const CONNECTED_PRIVACY_OVERLAY: Record<string, any> = {
  en: {
    sender: {
      body: "Send the match to your opponent. They receive the shared match facts and, if you have provided them, your self-declared tennis-profile facts. Your notes, ratings, readiness and health/watch data stay private.",
    },
    recipient: {
      privacyBody: "You receive the shared match facts plus the sender's self-declared tennis-profile facts when provided. Your ratings, notes, readiness and watch/health data belong only to you.",
      selfClaimError: "You cannot accept an invitation you sent yourself.",
    },
  },
  el: {
    sender: {
      body: "Στείλε τον αγώνα στον αντίπαλό σου. Θα λάβει τα κοινά στοιχεία του αγώνα και, αν τα έχεις συμπληρώσει, τα στοιχεία του τενιστικού προφίλ σου. Οι σημειώσεις, οι αξιολογήσεις απόδοσης, η ετοιμότητα και τα δεδομένα υγείας ή smartwatch παραμένουν ιδιωτικά.",
    },
    recipient: {
      privacyBody: "Λαμβάνεις τα κοινά στοιχεία του αγώνα και, εφόσον έχουν δηλωθεί, τα στοιχεία του τενιστικού προφίλ του αποστολέα. Οι δικές σου αξιολογήσεις απόδοσης, σημειώσεις, στοιχεία ετοιμότητας και δεδομένα υγείας ή smartwatch παραμένουν μόνο δικά σου.",
      selfClaimError: "Δεν μπορείς να αποδεχτείς πρόσκληση που έστειλες εσύ ο ίδιος.",
    },
  },
  es: {
    sender: {
      body: "Envía el partido a tu rival. Recibirá los datos compartidos del partido y, si los has indicado, los datos de tu perfil de tenis. Tus notas, valoraciones, preparación y datos de salud/reloj siguen siendo privados.",
    },
    recipient: {
      privacyBody: "Recibes los datos compartidos del partido y, si están disponibles, los datos de tenis declarados por el remitente. Tus valoraciones, notas, preparación y datos de salud/reloj son solo tuyos.",
      selfClaimError: "No puedes aceptar una invitación que enviaste tú mismo.",
    },
  },
  fr: {
    sender: {
      body: "Envoyez le match à votre adversaire. Il recevra les faits partagés du match et, si vous les avez renseignés, les informations de votre profil tennis. Vos notes, évaluations, préparation et données santé/montre restent privées.",
    },
    recipient: {
      privacyBody: "Vous recevez les faits partagés du match et, s'ils sont renseignés, les éléments du profil tennis déclarés par l'expéditeur. Vos évaluations, notes, préparation et données santé/montre restent uniquement à vous.",
      selfClaimError: "Vous ne pouvez pas accepter une invitation que vous avez vous-même envoyée.",
    },
  },
  de: {
    sender: {
      body: "Sende das Match an deinen Gegner. Er erhält die gemeinsamen Match-Fakten und, falls angegeben, deine selbst eingetragenen Tennisprofil-Daten. Notizen, Bewertungen, Bereitschafts- und Gesundheits-/Watch-Daten bleiben privat.",
    },
    recipient: {
      privacyBody: "Du erhältst die gemeinsamen Match-Fakten und, falls vorhanden, die selbst angegebenen Tennisprofil-Daten des Absenders. Deine Bewertungen, Notizen, Bereitschafts- und Gesundheits-/Watch-Daten gehören nur dir.",
      selfClaimError: "Du kannst eine Einladung, die du selbst gesendet hast, nicht annehmen.",
    },
  },
  it: {
    sender: {
      body: "Invia la partita al tuo avversario. Riceverà i dati condivisi della partita e, se li hai inseriti, i dati del tuo profilo tennis. Note, valutazioni, stato di preparazione e dati salute/watch restano privati.",
    },
    recipient: {
      privacyBody: "Ricevi i dati condivisi della partita e, se disponibili, i dati del profilo tennis dichiarati dal mittente. Le tue valutazioni, note, stato di preparazione e dati salute/watch restano solo tuoi.",
      selfClaimError: "Non puoi accettare un invito che hai inviato tu stesso.",
    },
  },
  ja: {
    sender: {
      body: "試合を相手に送信します。相手には共通の試合情報と、登録済みの場合はあなた自身が入力したテニスプロフィール情報だけが共有されます。メモ、評価、コンディション、健康・ウォッチデータは共有されません。",
    },
    recipient: {
      privacyBody: "共通の試合情報と、登録されている場合は送信者自身が入力したテニスプロフィール情報を受け取ります。あなたの評価、メモ、コンディション、健康・ウォッチデータはあなただけのものです。",
      selfClaimError: "自分で送った招待を自分で承認することはできません。",
    },
  },
};

